module.exports = "https://coursera_assets.s3.amazonaws.com/images/2571ca801e002dc482f2e660b4c8f66e.png";